<template>
  <el-dialog
      :visible.sync="visible"
      title="创建账单"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="90%"
  >
    <el-form
        :model="dataForm"
        :rules="dataRule"
        ref="dataForm"
        label-width="120px"
        class="query-form"
        :inline="true"
    >
      <el-form-item prop="receiptCode" label="请选择账期：" label-width="120px">
        <el-date-picker
            size="mini"
            v-model="dataForm.sendDateBegin"
            style="width: 140px;margin-right: 6px;"
            placeholder="账单开始时间"
            type="date"
            value-format="yyyy-MM-dd">
        </el-date-picker>
        <el-date-picker
            size="mini"
            v-model="dataForm.sendDateEnd"
            placeholder="账单结束时间"
            style="width: 140px;margin-right: 6px;"
            type="date"
            value-format="yyyy-MM-dd">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="外销合同号：" label-width="100px">
        <el-input type="text" size="mini" v-model="inputOrderCode" placeholder="外销合同号"
                  style="width: 120px;margin-right: 6px;"></el-input>
        <el-button size="mini" type="primary" @click="addOrderCode">添加</el-button>
      </el-form-item>
      <el-form-item prop="receiptCode" label="批次：" label-width="60px">
        <el-input type="text" size="mini" v-model="inputBatchCode" placeholder="关联批次"
                  style="width: 120px;margin-right: 6px;"></el-input>
        <el-button size="mini" type="primary" @click="addBatchCode">添加</el-button>
      </el-form-item>

    </el-form>
    <div class="table-bar" style="margin-bottom: 0">
      <div v-if="orderCodeList.length>0">
        外销合同:
        <el-tag v-for="(item,index) in orderCodeList" :key="index" type="success" size="mini" style="margin-right: 6px;"
                closable
                @close="orderCodeRemoved(item)">{{ item }}
        </el-tag>
      </div>
      <div v-if="batchCodeList.length>0">
        账单批次号:
        <el-tag v-for="(item,index) in batchCodeList" :key="index" type="success" size="mini" style="margin-right: 6px;"
                closable
                @close="batchCodeRemoved(item)">{{ item }}
        </el-tag>
      </div>
    </div>
    <SweetTable ref="table" api-version="v2" url="/trade/factorystorelog/query/can/bill" :query-form="dataForm"
                :before-table-binding="beforeTableBinding" :selection="true"
                :auto-load="false" :height="500" :is-page="false" :summaries-column="['sendCount','count','backCount']"
                @selection-change="handleSelectionChange">
      <el-table-column
          prop="orderCode"
          label="外销合同编号"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
          width="160"
      ></el-table-column>
      <el-table-column
          prop="receiptAccount"
          label="开票户头"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
          width="160"
      ></el-table-column>

      <el-table-column
          prop="batchCode"
          label="发货批次号"
          header-align="center"
          align="center"
          width="160"
          :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
          prop="receiverName"
          label="收货方"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
          width="160"
      ></el-table-column>
      <el-table-column
          label="货物信息"
          header-align="center"
          align="center"
      >
        <template #default="{row}">
          <div style="display: flex;align-items: center;">
            <el-tag type="danger" v-if="row.reason==='退货'" style="margin-right: 10px;">退货</el-tag>
            <ProductRowCard :product="row.product"></ProductRowCard>
          </div>
        </template>
      </el-table-column>
      <el-table-column
          prop="price"
          label="发货单价"
          header-align="center"
          align="center"
          width="100"
      >
      </el-table-column>
      <el-table-column
          prop="sendCount"
          label="发货数"
          header-align="center"
          align="center"
          width="100"
      >
      </el-table-column>
      <el-table-column
          label="收货数"
          header-align="center"
          align="center"
          prop="count"
          width="100"
      >
      </el-table-column>
      <!--      <el-table-column-->
      <!--          label="退货数"-->
      <!--          header-align="center"-->
      <!--          align="center"-->
      <!--          prop="backCount"-->
      <!--          width="100"-->
      <!--      >-->
      <!--      </el-table-column>-->
      <el-table-column
          label="发货时间"
          header-align="center"
          align="center"
          prop="operateTime"
          width="120"
      >
      </el-table-column>
      <el-table-column
          label="收货时间"
          header-align="center"
          align="center"
          prop="receiveOptTime"
          width="120"
      >
      </el-table-column>
    </SweetTable>
    <template #footer>
      <div style="display: flex;justify-content: space-between;align-items: center;font-size: 16px;font-weight: 500">
        <div v-if="previewData">
          账期：{{ dataForm.sendDateBegin }} 至 {{ dataForm.sendDateEnd }}，共
          <span class="number">{{ previewData.rowCounts }}</span> 条数据，已选择数量
          <span class="number"> {{ previewData.canReceiptCount }}</span>
          ，总金额
          <span class="number">¥{{ previewData.totalAmount }} </span>
        </div>
        <div>
          <el-button size="small" @click="visible = false">取消</el-button>
          <el-button type="primary" size="small" key="canSubmit" @click="doSubmit" :disabled="!canSubmit">
            创建账单并提交审核
          </el-button>
        </div>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import ProductRowCard from '@/components/ProductRowCard.vue'
import moment from 'moment'
import SweetTable from '@/mixins/SweetTable'
import BigNumber from 'bignumber.js'

/**
 * 创建账单弹窗
 */
export default {
  name: 'create-bill-dialog',
  mixins: [SweetTable],
  components: { ProductRowCard },
  data () {
    return {
      visible: false,
      dataForm: {
        page: 1,
        limit: 100000,
        sendDateBegin: '',
        sendDateEnd: '',
        isVirtual: 1,
        status: 20,
        hasReceipt: 0,
        queryType: 'seller',
        batchCodes: [],
        orderCodes: [],
        onlyPurchase: 1
      },
      previewData: {
        rowCounts: 0,
        canReceiptCount: 0,
        totalAmount: 0
      },
      dataRule: {},
      canSubmit: false,
      inputBatchCode: '',
      batchCodeList: [],
      inputOrderCode: '',
      orderCodeList: [],
      lock: false
    }
  },
  watch: {
    'dataForm.sendDateBegin': {
      handler (val) {
        this.reload()
      },
    },
    'dataForm.sendDateEnd': {
      handler (val) {
        this.reload()
      },
    },
    orderCodeList () {
      this.dataForm.orderCodes = this.orderCodeList.join(',')
      this.reload()
    },
    batchCodeList () {
      this.dataForm.batchCodes = this.batchCodeList.join(',')
      this.reload()
    }
  },
  computed: {},
  methods: {
    handleSelectionChange (dataList) {
      let totalReceiptCount = new BigNumber(0)
      let totalAmount = new BigNumber(0)
      dataList.forEach(item => {
        let rowCount = new BigNumber(item.count)
        totalReceiptCount = totalReceiptCount.plus(rowCount)
        totalAmount = totalAmount.plus(rowCount.multipliedBy(item.price))
      })
      this.previewData = {
        rowCounts: dataList.length,
        canReceiptCount: totalReceiptCount.toFixed(3),
        totalAmount: totalAmount.toFixed(2)
      }
      this.canSubmit = totalReceiptCount.toNumber() > 0
    },
    addOrderCode () {
      if (!this.inputOrderCode) {
        return
      }
      this.orderCodeList.push(this.inputOrderCode)
      this.inputOrderCode = ''
    },
    orderCodeRemoved (e) {
      this.orderCodeList.splice(this.orderCodeList.indexOf(e), 1)
    },
    addBatchCode () {
      if (!this.inputBatchCode) {
        return
      }
      this.batchCodeList.push(this.inputBatchCode)
      this.inputBatchCode = ''
    },
    batchCodeRemoved (e) {
      this.batchCodeList.splice(this.batchCodeList.indexOf(e), 1)
    },
    init () {
      this.canSubmit = false
      this.inputBatchCode = ''
      this.batchCodeList = []
      this.inputOrderCode = ''
      this.orderCodeList = []
      this.dataForm.sendDateEnd = moment().format('YYYY-MM-DD')
      this.dataForm.sendDateBegin = moment().subtract(1, 'months').format('YYYY-MM-DD')
      this.reload()
      this.visible = true
    },
    /**
     * 查询账单预览
     */
    beforeTableBinding (dataList) {
      dataList.forEach(item => {
        item.sendCount = new BigNumber(item.sendCount).multipliedBy(item.type).toFixed(3)
        item.count = new BigNumber(item.count).multipliedBy(item.type).toFixed(3)

      })
    },

    doSubmit () {
      let rows = this.$refs.table.dataListSelections
      if (this.$c.isArrayEmpty(rows)) {
        return this.$message.error('请选择要本次账单包含的明细')
      }
      let ids = rows.map(item => item.id)
      this.$confirm('确认创建账单并提交审核吗？').then(() => {
        if (this.lock) {
          return
        }
        this.lock = true
        this.$api2.post('/trade/factorystorelog/create/bill', { ids: ids }).then(res => {
          this.$message.success('创建账单成功，请等待审核')
          this.visible = false
          this.$emit('change')
          this.lock = false
        }).catch(err => {
          this.lock = false
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.number {
  color: red;
  margin: 0 5px;
  font-weight: bold;
}
</style>
